/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_DpaInputs */

const en_mk_mx_dpa = /** @type {(inputs: Mk_Mx_DpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data processing agreement (DPA)`)
};

const id_mk_mx_dpa = /** @type {(inputs: Mk_Mx_DpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perjanjian pemrosesan data (DPA)`)
};

/**
* | output |
* | --- |
* | "Data processing agreement (DPA)" |
*
* @param {Mk_Mx_DpaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_dpa = /** @type {((inputs?: Mk_Mx_DpaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_DpaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_dpa(inputs)
	return en_mk_mx_dpa(inputs)
});